// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.live2d-lip-sync .show {
  display: block;
}
.live2d-lip-sync .hide {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/features/student/practice/Live2DLipSync.scss"],"names":[],"mappings":"AACE;EACE,cAAA;AAAJ;AAGE;EACE,aAAA;AADJ","sourcesContent":[".live2d-lip-sync {\n  .show {\n    display: block;\n  }\n  \n  .hide {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
